import { Currency } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'

export function currencyId(currency: Currency): string {
  if (currency.isNative) {
    if (currency.chainId === SupportedChainId.PULSECHAIN) return 'PLS'
    if (currency.chainId === SupportedChainId.POLYGON || currency.chainId === SupportedChainId.POLYGON_MUMBAI)
      return 'MATIC'
    if (currency.chainId === SupportedChainId.BNB) return 'BNB'
    if (currency.chainId === SupportedChainId.CELO || currency.chainId === SupportedChainId.CELO_ALFAJORES)
      return 'CELO'
    return 'ETH'
  }
  if (currency.isToken) return currency.address
  throw new Error('invalid currency')
}
